<template>
	<div class="small-12 flex justify-center megaMenu animated fadeIn" v-show="future_item">
		<div class="small-12 columns wrap flex vertical-align">
			<div class="small-12 large-2 columns" style="height:1px;"></div>
			<div class="small-12 large-8 nav">
				<ul class="small-12 flex">
					<li class="small-3 columns flex">
						<a class="auto float-left small-12 columns">
							About Nestd
						</a>
					</li>
					<li class="small-3 columns flex">
						<a class="auto float-left small-12 columns">
							About Nestd
						</a>
					</li>
					<li class="small-3 columns flex">
						<a class="auto float-left small-12 columns">
							About Nestd
						</a>
					</li>
					<li class="small-3 columns flex">
						<a class="float-left small-12 columns">
							FAQs
						</a>
						<a class="float-left small-12 columns">
							Support Articles
						</a>
						<a class="float-left small-12 columns">
							Policies
						</a>
						<a class="float-left small-12 columns">
							Contact Us
						</a>
					</li>
				</ul>
			</div>
			<div class="small-12 large-2 columns" style="height:1px;"></div>
		</div>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'MegaMenu',

		/*
		**  Get the props
		*/

		props: {

			menuOpen: {
				type: Boolean,
				default: false
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false
			
		}),

		/*
		**  Do this first
		*/

		created() {

			window.addEventListener("click", this.closeCoursesMenu);

		},

		/*
		**  Do this last
		*/

		beforeDestroy() {

			window.removeEventListener("click", this.closeCoursesMenu);

		},

		/*
		**  Set up the methods
		*/

		methods: {

	        closeCoursesMenu(e) {

		    	if (this.menuOpen) {

		    		// Close the menu
	        		this.$emit('update:isInvestorsNavOpen', false);

		    	}

		    }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>